import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appIframeHeight]'
})
export class IframeHeightDirective {

  constructor(private el: ElementRef) { }

  @HostListener('window:resize')
  @HostListener('window:load')
  sendHeightToParent() {
    const height = this.el.nativeElement.scrollHeight;
    window.parent.postMessage({ type: 'DOCUMENT_HEIGHT', height: height }, '*');
  }
}
